import {
	CreateIndustry,
	Industry,
	IndustryArraySchema,
} from "@/pages/Private/pages/ManageIndustries/industry/schema/industry";
import { api } from "@/redux/api";

export const industryApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getIndustries: builder.query<Industry[], void>({
			query: () => ({
				url: "industry",
				responseSchema: IndustryArraySchema,
			}),
			providesTags: ["Industry"],
		}),
		createIndustry: builder.mutation<Industry, CreateIndustry>({
			query: (body) => ({
				url: "industry",
				method: "POST",
				body,
			}),
			invalidatesTags: ["Industry"],
		}),
		updateIndustry: builder.mutation<Industry, Industry>({
			query: (body) => ({
				url: `industry/${body.id}`,
				method: "PATCH",
				body,
			}),
			invalidatesTags: ["Industry"],
		}),
		deleteIndustry: builder.mutation<Industry[], number>({
			query: (id) => ({
				url: `industry/${id}`,
				method: "DELETE",
				responseSchema: IndustryArraySchema,
			}),
			invalidatesTags: ["Industry"],
		}),
	}),
});

export const {
	useGetIndustriesQuery,
	useCreateIndustryMutation,
	useUpdateIndustryMutation,
	useDeleteIndustryMutation,
} = industryApi;

export const industryApiReducer = industryApi.reducer;
export const industryApiMiddleware = industryApi.middleware;
